import { BookmakerDetail as BookmakerDetailComponent } from './BookmakerDetail.component';
import { connector } from './BookmakerDetail.connector';

export const BookmakerDetail = connector(BookmakerDetailComponent);
